import React from 'react';

// import DashboardByModule from '../../NTX/DashboardManagament/DashboardListByModule/DashboardByModule';
import DashboardByModule2 from '../../NTX/DashboardManagament/DashboardModule/Index';
import useGetDashboardWithPermission from '../../../hooks/NTX/Dashboard/useGetDashboardWithPermission';

//________________ Start Components
const DashboardHR: React.FC = () => {
  const { DashboardWithPermission } = useGetDashboardWithPermission();

  const dashboardListByModule = DashboardWithPermission?.filter(
    f => f?.moduleId?.toLowerCase() === '0a6c6b89-1d52-4eaa-8d2c-010c74b1f6e0'
  );

  return (
    <div>
      {/* <DashboardByModule dashboardList={dashboardListByModule} /> */}
      <DashboardByModule2 DashboardList={dashboardListByModule} />
    </div>
  );
};

export default DashboardHR;
